import {
  SET_BUBBLE_VISIBILITY,
  SET_REFERRER_HOST,
  SET_WIDGET_APP_CONFIG,
  SET_WIDGET_COLOR,
  TOGGLE_WIDGET_OPEN,
  SET_TIMERS_PARAMS,
  SET_PRECHAT_HIDDEN_FIELDS,
  SET_IS_SHOW_TRANSCRIPT_BUTTON,
  SET_IS_SHOW_FILE_TRANSFER_BUTTON,
  SET_IS_CHAT_OFFLINE
} from '../types';

export const state = {
  hideMessageBubble: false,
  isCampaignViewClicked: false,
  isWebWidgetTriggered: false,
  isWidgetOpen: false,
  position: 'right',
  referrerHost: '',
  showPopoutButton: false,
  widgetColor: '',
  widgetStyle: 'standard',
  darkMode: 'light',
  ac_custom_attributes: {},
  prechatHiddenFields: [],
  response_timeout: 0,
  end_conversation_timeout: 0,
  message_before_timeout: '',
  message_timeout: '',
  isShowTranscriptButton:true,
  isShowFileTransferButton: true,
  isChatOffline : false
};
// ac_custom_attributes: '{"message_timeout":"Bye","response_timeout":"5","message_before_timeout":"Respond please","end_conversation_timeout":"20"}',
export const getters = {
  getAppConfig: $state => $state,
  isRightAligned: $state => $state.position === 'right',
  getHideMessageBubble: $state => $state.hideMessageBubble,
  getIsWidgetOpen: $state => $state.isWidgetOpen,
  getWidgetColor: $state => $state.widgetColor,
  getReferrerHost: $state => $state.referrerHost,
  isWidgetStyleFlat: $state => $state.widgetStyle === 'flat',
  darkMode: $state => $state.darkMode,
  getResponse_timeout: $state => $state.response_timeout,
  getEnd_conversation_timeout: $state => $state.end_conversation_timeout,
  getMessage_before_timeout: $state => $state.message_before_timeout,
  getMessage_timeout: $state => $state.message_timeout,
  getTimersParams: $state => $state.ac_custom_attributes,
  getPrechatHiddenFields : $state => $state.prechatHiddenFields,
  getIsShowTranscriptButton : $state => $state.isShowTranscriptButton,
  getIsShowFileTransferButton: $state => $state.isShowFileTransferButton,
  getIsChatOffLine : $state => $state.isChatOffline
};

export const actions = {
  setAppConfig(
    { commit },
    {
      showPopoutButton,
      position,
      hideMessageBubble,
      widgetStyle = 'rounded',
      darkMode = 'light',
	    prechatHiddenFields,
      isShowTranscriptButton
    }
  ) {
    commit(SET_WIDGET_APP_CONFIG, {
      hideMessageBubble: !!hideMessageBubble,
      position: position || 'right',
      showPopoutButton: !!showPopoutButton,
      widgetStyle,
      darkMode,
	    prechatHiddenFields,
      isShowTranscriptButton
    });
  },
  toggleWidgetOpen({ commit }, isWidgetOpen) {
    commit(TOGGLE_WIDGET_OPEN, isWidgetOpen);
  },
  setWidgetColor({ commit }, widgetColor) {
    commit(SET_WIDGET_COLOR, widgetColor);
  },
  setReferrerHost({ commit }, referrerHost) {
    commit(SET_REFERRER_HOST, referrerHost);
  },
  setBubbleVisibility({ commit }, hideMessageBubble) {
    commit(SET_BUBBLE_VISIBILITY, hideMessageBubble);
  },
  setTimersParams({ commit }, ac_custom_attributes) {
    commit(SET_TIMERS_PARAMS, ac_custom_attributes);
  },
  setHiddenFields({commit}, prechatHiddenFields){
    commit(SET_PRECHAT_HIDDEN_FIELDS , prechatHiddenFields)
  },
  setIsShowTranscriptButton({commit}, isShowTranscriptButton){
    commit(SET_IS_SHOW_TRANSCRIPT_BUTTON , isShowTranscriptButton)
  },
  setIsShowFileTransferButton({commit}, isShowTranscriptButton){
    commit(SET_IS_SHOW_FILE_TRANSFER_BUTTON , isShowTranscriptButton)
  },
  setIsChatOffLine({commit} , isChatOffline){
    commit(SET_IS_CHAT_OFFLINE , isChatOffline)
  }
};

export const mutations = {
  [SET_WIDGET_APP_CONFIG]($state, data) {
    $state.showPopoutButton = data.showPopoutButton;
    $state.position = data.position;
    $state.hideMessageBubble = data.hideMessageBubble;
    $state.widgetStyle = data.widgetStyle;
    $state.darkMode = data.darkMode;
    $state.response_timeout = data.response_timeout;
    $state.end_conversation_timeout = data.end_conversation_timeout;
    $state.message_before_timeout = data.message_before_timeout;
    $state.message_timeout = data.message_timeout;
	  $state.prechatHiddenFields = data.prechatHiddenFields;
  },
  [TOGGLE_WIDGET_OPEN]($state, isWidgetOpen) {
    $state.isWidgetOpen = isWidgetOpen;
  },
  [SET_WIDGET_COLOR]($state, widgetColor) {
    $state.widgetColor = widgetColor;
  },
  [SET_REFERRER_HOST]($state, referrerHost) {
    $state.referrerHost = referrerHost;
  },
  [SET_BUBBLE_VISIBILITY]($state, hideMessageBubble) {
    $state.hideMessageBubble = hideMessageBubble;
  },
  [SET_TIMERS_PARAMS]($state, ac_custom_attributes) {
    $state.ac_custom_attributes = ac_custom_attributes;
  },
  [SET_PRECHAT_HIDDEN_FIELDS]($state ,prechatHiddenFields ){
    $state.prechatHiddenFields = prechatHiddenFields
  },
  [SET_IS_SHOW_TRANSCRIPT_BUTTON]($state ,isShowTranscriptButton ){
    $state.isShowTranscriptButton = isShowTranscriptButton
  },
  [SET_IS_SHOW_FILE_TRANSFER_BUTTON]($state ,isShowFileTransferButton ){
    $state.isShowFileTransferButton = isShowFileTransferButton
  },
  [SET_IS_CHAT_OFFLINE]($state , isChatOffline){
    $state.isChatOffline = isChatOffline 
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
